import type { Nullish } from '@iheartjane/types';

export const PROMPTS = {
  login: '__jane_bloom_login_prompt',
};

export type PromptsType = (typeof PROMPTS)[keyof typeof PROMPTS];

export function getPromptCookieName(
  prompt: PromptsType,
  cookiePrefix: Nullish<string>
): string {
  return `${cookiePrefix ?? ''}${prompt}`;
}
